<template>
    <v-dialog v-model="show" max-width="450" persistent no-click-animation scrollable>
        <div class="CampaignConversationFlow">
            <!--Header dialog-->
            <div class="dialog-header">
                <div>{{ $f.tc('details') }}</div>
                <v-btn small icon @click="close">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </div>
            <!-- Dialog body -->
            <div class="dialog-content">
                <template v-if="Object.keys(treeDebugData).length > 0">
                    <DebugFlow/>
                </template>
            </div>
        </div>
    </v-dialog>
</template>

<script>
import DialogMixin from "@/modules/fptai/mixins/DialogMixin.vue";
import DebugFlow from "@/views/Debug/DebugFlow.vue";
import {mapState} from "vuex";

export default {
    name: "CampaignConversationFlow",
    components: {DebugFlow},
    mixins: [DialogMixin],
    computed: {
        ...mapState({
            treeDebugData: state => state.debug.treeData,
        }),
    },
}
</script>

<style scoped lang="scss">
.CampaignConversationFlow {
    position: relative;
    background: #FFFFFF;
    border-radius: 5px !important;
    overflow: hidden;

    .btn-custom {
        margin-left: 8px;
    }

    .label {
        margin-top: 12px;
        font-family: "open sans semi";
        font-size: 13px;

        &:first-child {
            margin-top: 0 !important;
        }
    }

    .text-upload {
        font-size: 14px;
        padding: 12px;
    }

    .btn-delete {
        background: #dc3545 !important;
        color: #FFFFFF !important;
        border: 1px solid #dc3545 !important;

        &:hover {
            background: #dc3545bf !important;
            border: 1px solid #dc354500 !important;
        }
    }

    .btn-outline-delete {
        color: #dc3545 !important;
        border: 1px solid #dc3545 !important;

        &:hover {
            background: #ffabb3 !important;
            color: #dc3545 !important;
            //border: 1px solid #dc354500 !important;
        }
    }
}
::v-deep {
    .v-input--selection-controls {
        padding-top: 0 !important;
    }

    .v-input--selection-controls__ripple {
        display: none;
    }

    .v-text-field {
        padding-top: 0 !important;
        margin-top: 0 !important;
    }

    .v-input--selection-controls {
        margin-top: 0 !important;
    }

    .v-input--selection-controls.v-input .v-label {
        font-family: "open sans" !important;
        font-size: 14px !important;
        color: #2c3e50 !important;
    }
}
</style>
